import { UserRoleIDEnum, useToggle } from '@alluradirect/react';
import { Box, Link, Typography } from '@mui/material';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import { LoadingIndicator } from 'components/core/LoadingIndicator/LoadingIndicator';
import { useTermsOfServiceHTMLQuery } from 'hooks/api/core/useTermsOfServiceHTMLQuery';

export const UserSignUpTermsOfService = ({ userTypeId }: { userTypeId: UserRoleIDEnum }) => {
  const toggleTermsDialog = useToggle();
  const termsOfServiceQuery = useTermsOfServiceHTMLQuery({ user_type_id: userTypeId });
  if (!termsOfServiceQuery.data) return <LoadingIndicator />;
  return (
    <>
      <Box display="flex" flexDirection={'column'}>
        <Typography variant="caption" sx={{ display: 'flex' }}>
          By creating an account, you are accepting alluraDirect&apos;s
          <Link variant="caption" color="secondary" onClick={toggleTermsDialog.open} sx={{ paddingLeft: 0.5 }}>
            terms and conditions
          </Link>
        </Typography>
      </Box>
      {toggleTermsDialog.isOpen ? (
        <ConfirmationDialog
          isDialogOpen={toggleTermsDialog.isOpen}
          handleCloseDialog={toggleTermsDialog.close}
          dialogTitle="Terms & Conditions"
          hasBottomBar={false}
        >
          <div dangerouslySetInnerHTML={{ __html: termsOfServiceQuery.data.DATA.TOSSA }}></div>
        </ConfirmationDialog>
      ) : null}
    </>
  );
};
